// @flow
import {
  SET_LOADING,
} from "../../helpers/constants";

export type SetLoading<T> = {|
  type: typeof SET_LOADING,
  key: T,
  value: boolean,
|};

export type Actions<T> =
  SetLoading<T>;

export default <T: string>(key: T, value: boolean): SetLoading<T> => ({
  type: SET_LOADING,
  key,
  value,
});
